export enum LegListDisplayType {
  All = 1,
  ByDate = 2,
}
